import { CommonAPI } from "../Client";

export const getCourierConfigurationApi = (id) =>
  CommonAPI.get("/courier-configurations", { params: { id } });

export const postCourierConfigurationApi = (payload) =>
  CommonAPI.post("/courier-configurations", payload);

export const updateCourierConfigurationApi = (payload) =>
  CommonAPI.put("/courier-configurations", payload);

export const deleteCourierConfigurationApi = (id) =>
  CommonAPI.delete("/courier-configurations", { params: { id } });

export const getTenantCourierConfigurationApi = () =>
  CommonAPI.get("/courier-configurations/tenant");
